import {useEffect} from 'react'
import {useAuth} from '../../modules/auth'
import HrDashboard from './admin_dashboard/AdminDashboard'
import EmployeeDashboard from './employee_dashboard/EmployeeDashboard'
import AdminDashboard from './admin_dashboard/AdminDashboard'

  const DashboardWrapper = () => {
    const {currentUser} = useAuth()

    useEffect(() => {
      document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
      return () => {
        document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
      }
    }, [])

    //Admin & Employee Dashboard bases on designation (old code, replaced by role-based logic below)

//     const isAdmin =
//       currentUser?.designation?.name?.toLowerCase() === 'admin'

//     return <>{isAdmin ? <AdminDashboard /> : <EmployeeDashboard />}</>
//   }

    //Admin & Employee Dashboard based on roles (new logic, more robust and flexible)

  //  Normalize roles safely (handles all cases)
  const normalizeRole = (r) => {
    const name =
      typeof r === 'string'
        ? r
        : r?.name || r?.role?.name

    return name
      ? name.toLowerCase().replace(/\s+/g, '_')
      : ''
  }

  const roles = currentUser?.userRoles?.map(normalizeRole) || []

  //  Role checks
  const isAdmin =
    roles.includes('admin') ||
    roles.includes('super_admin')

  const isHR = roles.includes('hr')

  //  Render dashboard
  if (isAdmin) return <AdminDashboard />

  return <EmployeeDashboard />
}

export { DashboardWrapper }
